import { ISchema, PaywallComponentProps } from '../../../@types'

const PROGRAM_LABELS: Record<string, string> = {
	pilates: 'Pilates',
	calisthenics: 'Calisthenics',
	tai_chi_walking: 'Tai Chi Walking',
	yoga: 'Yoga',
	walking: 'Walking',
	fasting: 'Fasting',
}

export default (schema: ISchema): ISchema => {
	// US (enforceWeeklyTexts) shows bonus plans above the money-back line; default/EU keep it below
	const bonusPlansAfter = schema.config?.enforceWeeklyTexts ? 'PaywallUserResearchBadge' : 'PaywallTextLine'

	return {
		...schema,
		order: (schema.order ?? []).flatMap((item) => {
			const name = Array.isArray(item) ? item[0] : item
			return name === bonusPlansAfter ? [item, 'PaywallBonusPlans'] : [item]
		}),
		components: {
			...schema.components,
			PaywallBonusPlans: (args): PaywallComponentProps.BonusPlans => ({
				title: 'Bonus plans included:',
				items: (args.ctx?.answerAdditionalPrograms ?? [])
					.map((value) => PROGRAM_LABELS[value])
					.filter(Boolean)
					.map((label) => ({ label, oldPrice: '$9.99', badge: 'FREE' })),
			}),
		},
	}
}
